import {OptionType} from "../../config/pax";

export type TravelItemLabel = {
    text: string;
    legend: string;
};

export type selectionDate = {
    day: OptionType;
    month: OptionType;
    year: OptionType;
};

export const TravelItems: {
    adults: TravelItemLabel;
    children: TravelItemLabel
} = {
    adults: {text: "Adultes", legend: "(18+)"},
    children: {text: "Enfants", legend: "(de 0 à -18 ans)"}
};